module.exports = __webpack_public_path__ + "img/logo_white.573302de.svg";